import CreatorLayout from 'components/CreatorLayout'
import AsyncRoute from 'components/AsyncRoute'
import { Redirect, Switch } from 'react-router-dom'

export interface CreatorRoutesProps {}

function CreatorRoutes({}: CreatorRoutesProps) {
  return (
    <CreatorLayout>
      <Switch>
        <AsyncRoute path='/settings' page='creator/Settings' />
        <AsyncRoute exact path='/products' page='creator/Products' />
        <AsyncRoute path='/product/:id' page='creator/Product' />
        <Redirect to='/products' />
      </Switch>
    </CreatorLayout>
  )
}

export default CreatorRoutes
